import { IconComponent } from '../icon.types';

export const DiviceIcon: IconComponent = (props) => (
  <svg
    width="101"
    height="102"
    viewBox="0 0 101 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      y="25"
      width="80"
      height="80"
      rx="40"
      transform="rotate(-18 0 25)"
      fill="#FFCE27"
    />
    <g clipPath="url(#clip0_499_1806)">
      <path
        d="M33.4282 37.2708L43.1623 67.229C43.9289 69.5886 46.473 70.8849 48.8326 70.1182L63.0984 65.483C65.458 64.7163 66.7543 62.1722 65.9876 59.8126L56.2536 29.8543L33.4282 37.2708ZM57.4281 62.5938L51.7218 64.4479L50.7947 61.5947L56.5011 59.7406L57.4281 62.5938Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_499_1806">
        <rect
          width="36"
          height="36"
          fill="white"
          transform="translate(27.7217 39.1249) rotate(-18)"
        />
      </clipPath>
    </defs>
  </svg>
);
